import Vue from 'vue'

// //not-images
// import not_imageBanner from '../components/not_images/not_imageBanner'
// import not_imageShow from '../components/not_images/not_imageShow'
// import not_imageCrop from '../components/not_images/imageCrop'

// import not_googleMap from '../components/not_maps/not_googleMap'
import not_mapBox from '../components/not_maps/not_mapBox'
import not_mapBox2 from '../components/not_maps/not_mapBox2'

import not_footer from '../components/not_sections/not_footer' 
import not_page_spinner from '../components/not_sections/not_page_spinner'
import not_pager from '../components/not_sections/not_pager'
 
import not_navbar from '../components/not_toolbars/not_navbar'
import not_toolbar from '../components/not_toolbars/not_toolbar'
import not_toolbar_sub from '../components/not_toolbars/not_toolbar2'
// import not_cpanel_tab from '../components/not_toolbars/not_cpanel_tab'
import not_progress_div from '../components/not_toolbars/not_progress_div'

import not_dialog from '../components/not_menus/not_dialog'
import not_dialog_cp from '../components/not_menus/not_dialog_cp'
import not_dialogProgress from '../components/not_menus/not_dialogProgress'

//table
import resultsTable from '../components/not_tables/resultsTable'
import resultsTable2 from '../components/not_tables/resultsTable2'

//not-file-selecter
import excelSelecter from "../components/not_file_selecter/excelSelecter"

//charts
import not_bar_chart from "../components/not_charts/bar_chart/not_bar_chart"
import not_bar_chart2 from "../components/not_charts/bar_chart/not_bar_chart2"
import not_pie_chart from "../components/not_charts/pie_chart/not_pie_chart"
import not_list_chart from "../components/not_charts/not_list_chart"

//error
import not_page_access_deny from "../components/not_error/not_page_access_deny"

 



// //not-images
// Vue.component('not-image-banner', not_imageBanner)
// Vue.component('not-image-show', not_imageShow) 
// Vue.component('not-image-crop', not_imageCrop) 

// //Vue.component('not-map-google', not_googleMap)
Vue.component('not-map-box', not_mapBox)
Vue.component('not-map-box2', not_mapBox2)

Vue.component('not-footer', not_footer)  
Vue.component('not-page-spinner', not_page_spinner)
Vue.component('not-pager', not_pager)
  
Vue.component('not-navbar', not_navbar)
Vue.component('not-toolbar', not_toolbar) 
Vue.component('not-toolbar-sub', not_toolbar_sub) 
// Vue.component('not-cpanel-tab', not_cpanel_tab) 
Vue.component('not-progress-div', not_progress_div) 

Vue.component('not-dialog', not_dialog) 
Vue.component('not-dialog-cp', not_dialog_cp) 
Vue.component('not-dialog-p', not_dialogProgress) 

//tables
Vue.component('not-table-results', resultsTable) 
Vue.component('not-table-results2', resultsTable2) 

//not-file-selecter
Vue.component('not-selecter-excel',excelSelecter)
//chart
Vue.component('not-chart-bar',not_bar_chart)
Vue.component('not-chart-bar2',not_bar_chart2)
Vue.component('not-chart-pie',not_pie_chart)
Vue.component('not-list-chart',not_list_chart)
//map
Vue.component('not-map-box',not_mapBox)

//error
Vue.component('not-access-deny-page',not_page_access_deny)